module.exports = __webpack_public_path__ + "img/img28.899481c6.png";